<template>
    <div>
        <mySearch
            :searchParams="listParams"
            :inputArr="inputParams"
            timeScreen
            @searchEvent="searchEvent"
            @searchTime="searchTime"
        >
            <el-select
                v-model="listParams.sourceUrl"
                clearable
                filterable
                remote
                reserve-keyword
                placeholder="请选择或输入网址"
                :remote-method="remoteMethod"
                v-loading="loading1"
                @change="selectChange"
                @focus="selectFocus"
            >
                <el-option
                    v-for="item in urlOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.url"
                >
                </el-option>
            </el-select>
        </mySearch>

        <my-table
            :tableData="tableData"
            :loading="loading"
            :tableHeader="tableDataHeader"
            ref="table"
            :pageParams="pageParams"
        >
            <template>
                <el-table-column label="状态" align="center" prop="status">
                    <template slot-scope="scope">
                        <span class="length-block">
                            {{ scope.row.status | formatStatus }}
                        </span>
                    </template></el-table-column
                >
            </template>
        </my-table>

        <!-- 分页 -->
        <my-pagination :childMsg="pageParams" @callFather="callFather">
        </my-pagination>

        <!-- 详情对话框 -->
        <el-dialog title="文章内容" :visible.sync="dialogVisible" width="30vw">
            <div
                class="articalContent"
                v-html="transHtml"
                v-loading="loading2"
            ></div>
        </el-dialog>
    </div>
</template>

<script>
import { ywDetails, repDocList, urlList } from "@/network/mochaItom/index.js";
export default {
    data() {
        return {
            dialogVisible: false, //详情对话框
            timeParams: null, //时间范围
            transHtml: "", //详情html内容
            urlOptions: [], //网址列表
            pageParams: {
                //分页参数
                currentPage: 1,
                pageSize: 15,
                total: 0,
            },
   
            loading1: false, //网址下拉框搜索
            loading: false,
            loading2: false, //内容
            tableDataHeader: Object.freeze([
                {
                    name: "文档标题",
                    prop: "docTitle",
                },
                {
                    name: "标签",
                    prop: "docTags",
                },
                {
                    name: "来源单位",
                    prop: "createUnit",
                },
                {
                    name: "来源url",
                    prop: "sourceUrl",
                    clickFun: function (val) {
                        window.open(val.sourceUrl, "_blank");
                    },
                },
                {
                    name: "文档简介",
                    prop: "docIntroduction",
                },
                {
                    name: "startTime",
                    prop: "createTime",
                },
                {
                    prop: "operation",
                    name: "操作",
                    Width: "100px",
                    operation: [
                        {
                            icon: "el-icon-search",
                            name: "详情",
                            clickFun: this.watchDetails,
                        },
                    ],
                },
            ]),
            tableData: [],
            inputParams: [
                {
                    defaultText: "请输入文档名称",
                    name: "docTitle",
                },
            ],
            listParams: {
                startTime: "",
                endTime: "",
                docTitle: "",
                sourceUrl: "https://techcrunch.com/",
            },
        };
    },
    created() {
        this.getUrlList();
        this.getInitData();
    },
    methods: {
        async getUrlList(url = "") {
            //信源网址
            let params = {
                current: 1,
                size: 100,
                data: {
                    url: url,
                },
            };
            let { data } = await urlList(params); //解析赋值
            if (data.code == 200) {
                let { records } = data.data;
                this.urlOptions = records;
                // this.listParams.sourceUrl = this.urlOptions[0].url;
            }
        },
        async remoteMethod(url) {
            // 搜索网址事件
            this.loading1 = true;
            await this.getUrlList(url);
            this.loading1 = false;
        },
        selectChange(val) {
            //网址选择下拉框触发
            this.getInitData();
        },
        selectFocus() {
            this.getUrlList();
        },
        getInitData(current, size) {
            //文章列表
            this.loading = true;
            repDocList({
                current: this.pageParams.currentPage,
                size: this.pageParams.pageSize,
                ...this.listParams,
            })
                .then((res) => {
                    if (res.data.code == 200) {
                        let data = res.data.data.records;
                        this.tableData = res.data.data.records;
                        this.pageParams.total = res.data.data.total;
                    }
                    this.loading = false;
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        watchDetails(val) {
            //点击详情
            this.loading2 = true;
            this.dialogVisible = true;
            this.transHtml = "";
            ywDetails({
                docId: val.id,
            })
                .then((res) => {
                    if (res.data.code == 200) {
                        var data = res.data.data;
                        this.transHtml = data.transHtml;
                    }
                    this.loading2 = false;
                })
                .catch((err) => {});
        },
        searchEvent() {
            //搜索事件
            // this.listParams.docTitle = this.inputParams[0].value;
            this.pageParams.currentPage = 1;
            this.getInitData();
        },
        searchTime(val) {
            //时间选择
            this.listParams.startTime = val[0];
            this.listParams.endTime = val[1];
        },
        //分页插件事件
        callFather(parm) {
            this.pageParams.currentPage = parm.currentPage;
            this.pageParams.pageSize = parm.pageSize;
            this.getInitData();
        },
    },
};
</script>
<style scoped>
.articalContent {
    width: 100%;
    height: 60vh;
    overflow: auto;
}
::-webkit-scrollbar {
    width: 0 !important;
    height: 0;
}

.totalCount {
    font-size: 14px;
    color: #a7a7a7;
    margin-left: 10px;
}
</style>